module.exports = __webpack_public_path__ + "static/media/whatsapp-social-media-svgrepo-com.d9514570.svg";